import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icons from '../../../../../common/widgets/Icons';
import Loader from '../../../../../common/widgets/Loader';
import LoadingSpinner from '../../../../../common/widgets/LoadingSpinner';
import { CitySuggestion } from '../../../models/Discover';
import { resources } from '../../../resources/resources';

interface ISuggestionProps {
  suggestions: CitySuggestion[] | null;
  searchValue: string;
  isLoading: boolean;
  suggestionsRef: any;
  onClick: (suggestion: CitySuggestion) => void;
}

const PromoSearchSuggestions = (props: ISuggestionProps) => {
  const { t: translate } = useTranslation();
  const { suggestions, searchValue, isLoading, suggestionsRef, onClick } =
    props;

  const [focusedIndex, setFocusedIndex] = useState(-1);

  const handleKeyDown = (e: any) => {
    if (suggestions) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setFocusedIndex(prevIndex =>
          prevIndex < suggestions.length - 1 ? prevIndex + 1 : prevIndex,
        );
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setFocusedIndex(prevIndex => (prevIndex > 0 ? prevIndex - 1 : -1));
      } else if (e.key === 'Enter' && focusedIndex !== -1) {
        onClick(suggestions[focusedIndex]);
      }
    }
  };

  useEffect(() => {
    setFocusedIndex(-1);
  }, [suggestions]);

  return (
    <>
      {suggestions !== null && (
        <div className="discover-search-suggestions">
          <ul ref={suggestionsRef} onKeyDown={handleKeyDown} tabIndex={0}>
            <Loader
              loading={isLoading}
              loader={<LoadingSpinner size="small" />}
            >
              {suggestions?.length > 0 ? (
                suggestions?.map((suggestion, index) => {
                  return (
                    <li
                      key={suggestion.filterId}
                      className={`suggestion-item ${
                        focusedIndex === index ? 'focused-suggestion' : ''
                      }`}
                      onClick={() => onClick(suggestion)}
                    >
                      <Icons.SearchList />
                      <div>{suggestion.cityName}</div>
                    </li>
                  );
                })
              ) : (
                <li className="no-results-suggestion">
                  <div>{`${translate(
                    resources.searchPage.noResults.title,
                  )} "${searchValue}"`}</div>
                </li>
              )}
            </Loader>
          </ul>
        </div>
      )}
    </>
  );
};

export default PromoSearchSuggestions;
